import EcommerceItem from "@/types/gtm/EcommerceItem";

import { defaultQuoteData } from "../default-quote-event-data";

export const defaultConfirmationEventData = {
  ...defaultQuoteData,
  ss_order_metrics: "XXXXXXX",
  ecommerce: {
    currency: "GBP",
    item_list_id: "recommended_policies",
    item_list_name: "recommended policies",
    transaction_id: "",
    items: [] as EcommerceItem[],
  },
};
